
var photoFlip;
var $cards;
var lastCardIndex = 6;

var pageIndex;
var $prevPage;
var $nextPage;
let questionCount;

$(function() {

	$(document).on('click', '.js-toggleInfluenceTextbox', function(e) {
		$(this).addClass('selected');
	});

	pageIndex = 0;

	$(document).on('mouseenter', '.photo-row', function(e) {
		var $card = $(this).children('.photo-card');
		$card.stop(true,false);
		$card.toggleClass('flip');
		clearInterval(photoFlip);
	});

	$(document).on('mouseleave', '.photo-row', function(e) {
		instantiatePhotoFlip();
	});

	$(document).on('click', '.js-nextPage', function(e) {
		e.preventDefault();
		if ( $(this).hasClass('disabled') ) {
			return false;
		}

		nextPage( pageIndex+1 );
	});

	$(document).on('click', '.js-previousPage', function(e) {
		e.preventDefault();
		nextPage( pageIndex-1 );
	});

	$(document).on('click', '.js-surveyAnswer', function(e) {
		e.preventDefault();
		if ( $(this).hasClass('selected') ) {
			return false;
		}

		selectSurveyAnswer( $(this).attr('data-name'), $(this).val() );
	});

	$(document).on('click', '.js-toggleStyleTextbox', function(e) {
		e.preventDefault();
		toggleStyleTextarea();
		setTimeout(function() {
			$('.js-preferredStyleTextbox').focus();
			$('body,html').animate({scrollTop:5000},10);
		},100);		
	});

	$(document).on('click', '.js-toggleInfluenceTextbox', function(e) {
		e.preventDefault();
		toggleInfluenceTextarea();
		setTimeout(function() {
			$('.js-preferredInfluenceTextbox').focus();
			$('body,html').animate({scrollTop:5000},10);
		},100);		
	});

	$(document).on('keyup', '.js-preferredStyleTextbox', function() {
		var $textarea = $(this);
		var value = $textarea.val().replace(/^\s\s*/g, '').replace(/\s\s*$/g, '');
		if ( value.length < 4 ) {
			// Disable Next Button
			$(document).find('.js-nextPage').each(function() {
				if ( $(this).attr('data-name') == $textarea.attr('data-name') ) {
					$(this).addClass('disabled');
				}
			});
		} else {
			// Disable Next Button
			$(document).find('.js-nextPage').each(function() {
				if ( $(this).attr('data-name') == $textarea.attr('data-name') ) {
					$(this).removeClass('disabled');
				}
			});
		}
	});

	$(document).on('keyup', '.js-preferredInfluenceTextbox', function() {
		var $textarea = $(this);
		var value = $textarea.val().replace(/^\s\s*/g, '').replace(/\s\s*$/g, '');
		if ( value.length < 4 ) {
			// Disable Next Button
			$(document).find('.js-nextPage').each(function() {
				if ( $(this).attr('data-name') == $textarea.attr('data-name') ) {
					$(this).addClass('disabled');
				}
			});
		} else {
			// Disable Next Button
			$(document).find('.js-nextPage').each(function() {
				if ( $(this).attr('data-name') == $textarea.attr('data-name') ) {
					$(this).removeClass('disabled');
				}
			});
		}
	});

	instantiatePhotoFlip();

	let survey;
	if ( localStorage && localStorage.getItem('survey') ) {
		survey = JSON.parse( localStorage.getItem('survey') );
	}
	
	if ( $('body').attr('data-surveycompleted') == "true" ) {
		// Survey was previously submitted so send the viewer
		// to the Thank You page
		pageIndex = $('.survey-page').length - 2;
		console.log("Survey was previously submitted so send the viewer to the Thank You page");
		readJsonString( localStorage.getItem('survey') );	

	} else if ( survey ) {
		if ( survey.opportunityId == $('body').attr('data-opportunityid') ) {
			readJsonString( localStorage.getItem('survey') );	
		} else {
			nextPage(pageIndex);
		}		
	} else {
		nextPage(pageIndex); 
	}
});


function selectSurveyAnswer( name, answer ) {
	var $answer;
	var foundOne = false;

	$(document).find('.js-surveyAnswer').each(function() {
		$answer = $(this);
		if ( $answer.attr('data-name') == name && $answer.attr('value') == answer ) {
			foundOne = true;
			
			// Special case, highlight radio inspiration...
			if ( $answer.attr('data-name') == "Impact On Investment Level" ) {
				$('.radio-inspiration').addClass('on');
			}

			// Special case, toggle custom influences appliances textarea box
			if ( $answer.attr('data-name') == "Appliance Influence" && $('textarea[name=appliance-influence]').hasClass('selected') ) {
				toggleInfluenceTextarea(); // turn it off
			}

			// Special case, toggle custom preferred style textarea box
			if ( $answer.attr('data-name') == "Preferred Style" && $('textarea[name=preferred-style]').hasClass('selected') ) {
				toggleStyleTextarea(); // turn it off
			}


			if ( $answer.attr('data-name') == "Main Level Flooring") {
				/* console.log("THEY PICKED ONE... turn the other off...");
				console.log($answer.attr('value')); */
				//Hardwood or Tile

				if ($answer.attr('value') == "Hardwood") {
					//remove tile from the questions
					$(".js-page-hardwood").addClass("survey-page");
					$(".js-page-tile").removeClass("survey-page");
				} else if  ($answer.attr('value') == "Tile") {
					//remove tile from the questions
					$(".js-page-hardwood").removeClass("survey-page");
					$(".js-page-tile").addClass("survey-page");
				} 

				
			}

			// Find any other answers that were selected before...
			$(document).find('.js-surveyAnswer').each(function() {
				if ( $(this).attr('data-name') == name ) {
					$(this).removeClass('selected');
				}
			});

			// Update any dynamic text of the answer selected...
			$(document).find('.js-dynamicText').each(function() {
				if ( $(this).attr('data-rel') == name ) {
					$(this).text( answer );
				}
			});

			// Select the new answer
			$answer.addClass('selected');

			// Enable the page "next" button
			$(document).find('.js-nextPage').each(function() {
				if ( $(this).attr('data-name') == name ) {
					$(this).removeClass('disabled');
				}
			});

			return false;
		}
	});

	// Special case, textarea preferred style
	if ( !foundOne && name == "Preferred Style" ) {
		toggleStyleTextarea(); // turn on textarea
		$('.js-preferredStyleTextbox').val( answer );
		// Enable the page "next" button
		$(document).find('.js-nextPage').each(function() {
			if ( $(this).attr('data-name') == name ) {
				$(this).removeClass('disabled');
			}
		});
	}

	// Special case, textarea influence
	if ( !foundOne && name == "Appliance Influence" ) {
		toggleInfluenceTextarea(); // turn on textarea
		$('.js-preferredInfluenceTextbox').val( answer );
		// Enable the page "next" button
		$(document).find('.js-nextPage').each(function() {
			if ( $(this).attr('data-name') == name ) {
				$(this).removeClass('disabled');
			}
		});
	}

	if ( localStorage ) {
		localStorage.setItem('survey', toJsonString());
	}
}


// Converts all questions & answers into a json object
function toJsonString() {
	var survey = {
		type: "designStudio",
		opportunityId: $('body').attr('data-opportunityid'),
		responses: {}
	};
	var index = 1;
	var answer, question;
	var matrixCount = {};

	$(document).find('.js-surveyAnswer.selected').each(function() {
		answer = $(this).val();
		question = $(this).attr('data-name');

		var matrix = {};
		var matrixPara = $(this)[0].getElementsByTagName('p');

		if (matrixPara.length > 0) {
			matrix = JSON.parse(matrixPara[0].textContent);

			//Adding in the matrix to the answer breaks the localStorage reading... 
			//answer += "- Matrix:\n" + JSON.stringify(matrix);
			for (const mtx in matrix) {
				if (matrixCount.hasOwnProperty(mtx)) {
					matrixCount[mtx]+= matrix[mtx];
				} else {
					matrixCount[mtx] = matrix[mtx];
				} 
			}
		}	
		
		survey.responses[index+""] = {
			question: question,
			answer: answer
		};
		index++;
	});

	let mCount = {}
	let m = Object.entries(matrixCount).sort((a,b) => b[1]-a[1])


	survey.responses[index+""] = {
		question: "Selected Style",
		answer: m
	};



	

	return JSON.stringify(survey);
}


function readJsonString( str ) {

	var survey = JSON.parse( str );
	var questionCount = 0;

	if (!survey) {
		//console.log("localstorage is null")
		//surveyData is writen to the page via survey.php from the txt file
		survey = surveyData;
	} 

	for ( const prop in survey?.responses ) {
		if ( parseInt(prop) > questionCount ) {
			questionCount = parseInt(prop);
		}
		selectSurveyAnswer( survey.responses[prop].question, survey.responses[prop].answer );
	}

	// Flip to the next unanswered page
	pageIndex = questionCount; //+ 1; //don't need to jump one more since there's the matrix at the end now
	nextPage(pageIndex, survey?.responses);
}


function nextPage(index, responses) {

	var totalPages = $('.survey-page').length - 2; //-2 for both closing pages
	var $prevPage = $('.survey-page').eq(pageIndex);
	var $nextPage = $('.survey-page').eq(index);
	
	$prevPage.addClass('previous');

	const urlParams = new URLSearchParams(window.location.search);
	var region = '';
	if(urlParams.has('region')) {
		region = urlParams.get('region').toLowerCase();
	}

	// Page animations for NEXT pages
	if ( index > pageIndex && !$nextPage.hasClass('answered') ) {
		$prevPage.addClass('answered');
		
		pageIndex = index;

		// Scroll to the top
		setTimeout(function() {
			$('body,html').animate({scrollTop:0},50);
		},1000);

		if(totalPages == index && region === 'pa') {
			//Show VIsualizer Slide
			setTimeout(function(){
				let theResponses = JSON.parse(localStorage.getItem('survey'));
				$prevPage.removeClass('on').removeClass('previous');
				showVisualizerSlide(theResponses.responses);		
			}, 1100);
			
		} else {
			//Show NON Visualizer Slode 
			$nextPage.addClass('next');
			setTimeout(function(){
				$prevPage.removeClass('on').removeClass('previous');
				$nextPage.addClass('on').removeClass('next');			
			}, 1100);
		}
		
	} else {
		// Quick page transition for PREVIOUS pages

		if(totalPages == index && region === 'pa') {
			console.log('survey complete');
			$prevPage.removeClass('on');
			showVisualizerSlide(responses);

		} else {
			$prevPage.removeClass('on');
			$nextPage.addClass('on').addClass('quickly');
			
			pageIndex = index;
			setTimeout(function(){
				$nextPage.removeClass('quickly');
				$prevPage.removeClass('previous');
			}, 100);
		}

		
	}

	// Add footer shadow if content scrolls...
	if ( $nextPage.find('.survey-answers-wrapper .wrapper').height() > ($(window).height() - $nextPage.find('.survey-header').height() - $nextPage.find('.survey-footer').height()) ) {
		$nextPage.find('.survey-footer').addClass('show-shadow');
	} else {
		$nextPage.find('.survey-footer').removeClass('show-shadow');
	}

	// Animate the progress bar...
	$('.js-surveyProgressBar').stop(true,false);
	$('.js-surveyProgressBar').css('width', (pageIndex/totalPages*100) + '%' );

	// All Done! Submit the form!
	if ( pageIndex == $('.survey-page').length - 2 ) {
		submitSurvey();
	}
}

function showVisualizerSlide(responses) {
	//console.log('showVisualizerSlide');
	$('.survey-page.tovisualizer').addClass('on').addClass('quickly');	

	let choosenKV = responses[10].answer[0][0];

	const test = collectionsData.find(function(kitchen) {
		return kitchen.name == choosenKV.toUpperCase();
	});


	const found = collectionsData.find(kitchen => kitchen.name.toUpperCase() == choosenKV.toUpperCase());

	let pickedName = found.name;
	let pickedImage = found.summary.previewImage;
	//console.log(pickedName, pickedImage);

	$('.js-recommenedName').html(choosenKV);
	$('.js-recommenedImage').attr('src', pickedImage);

	$(document).on('click', '.js-jumptovisualizer', function(e) {
		
		var oID = $('body').attr('data-opportunityid');
		//console.log("go to visiualizer page...", oID);

		let form = document.createElement('form');
		form.style.visibility = 'hidden';
		form.method = 'POST';
		form.action = "/visualizer/" + oID;
		var input = document.createElement('input');
		input.name = "pickedCollection";
		input.value = JSON.stringify(found);
		form.appendChild(input)
		document.body.appendChild(form);
		form.submit();

	});
}

function submitSurvey() {

	var surveyResults = "survey=" + toJsonString();
	var sID = $('body').attr('data-sessionid');
	var oID = $('body').attr('data-opportunityid');

	
	// Check to make sure this isn't a blank form submission
	// - Usually caused by someone who completed the survey
	//   and then refreshed their browser on the last page.
	var surveyTest = JSON.parse(toJsonString());

	if ( typeof surveyTest.responses['1'] == 'undefined' ) {
		return false; // quit early
	}

	
	surveyResults += "&session_id=" + sID;


	if (oID !== "vince") { //this should maybe be dev=true for testing

		$.post( '/survey-form-results.php', surveyResults )
			.done(function( d ) {
				if ( d != 'success' ) {
					$('.survey-page.introduction.closing').find('.survey-headline').text('Something Went Wrong.');
					$('.survey-page.introduction.closing').find('p.text').text('Our apologies - something went wrong submitting your Survey results. Please refresh this page to try again.');
					localStorage.clear();
				}
			})
			.fail(function( d ) {
				if ( d.status != 409 ) {
					$('.survey-page.introduction.closing').find('.survey-headline').text('Something Went Wrong.');
					$('.survey-page.introduction.closing').find('p.text').text('Our apologies - something went wrong submitting your Survey results. Please refresh this page to try again.');
					localStorage.clear();
				}
			});
	} else {
		console.log("Testing Only");
		console.log(surveyResults);
		// alert(surveyTest.responses['10'].answer.join("\n"));
	} 
}

function instantiatePhotoFlip() {
	if ( !$('.photo-card').length ) {
		return false;
	}
	clearInterval(photoFlip);
	photoFlip = setInterval(function() {
		if ( !$('.survey-page.on').find('.photo-card').length ) {
			return false;
		}
		var $cards = $('.survey-page.on').find('.photo-card');
		var cardIndex;
		do {
			cardIndex = Math.floor(Math.random() * $cards.length);
		} while ( cardIndex == lastCardIndex );
		lastCardIndex = cardIndex;
		$($cards[cardIndex]).stop(true,false);
		$($cards[cardIndex]).toggleClass('flip');
	},2500);
}

function toggleStyleTextarea() {
	var $textarea = $('textarea[name=preferred-style]');
	var $toggleBtn = $('.js-toggleStyleTextbox');

	if ( $textarea.hasClass('selected') ) {
		// Disable the page "next" button
		$(document).find('.js-nextPage').each(function() {
			if ( $(this).attr('data-name') == $textarea.attr('data-name') ) {
				$(this).addClass('disabled');
			}
		});

		// Find any other answers that were selected before...
		$(document).find('.js-surveyAnswer').each(function() {
			if ( $(this).attr('data-name') == $textarea.attr('data-name') ) {
				$(this).removeClass('selected');
			}
		});

		$textarea.val('').removeClass('selected');
		$toggleBtn.removeClass('off');
	} else {
		// Disable the page "next" button
		$(document).find('.js-nextPage').each(function() {
			if ( $(this).attr('data-name') == $textarea.attr('data-name') ) {
				$(this).addClass('disabled');
			}
		});

		// Find any other answers that were selected before...
		$(document).find('.js-surveyAnswer').each(function() {
			if ( $(this).attr('data-name') == $textarea.attr('data-name') ) {
				$(this).removeClass('selected');
			}
		});

		$textarea.val('').addClass('selected');
		$toggleBtn.addClass('off');		
	}
}



function toggleInfluenceTextarea() {
	var $textarea = $('textarea[name=appliance-influence]');
	var $toggleBtn = $('.js-toggleInfluenceTextbox');

	if ( $textarea.hasClass('selected') ) {
		// Disable the page "next" button
		$(document).find('.js-nextPage').each(function() {
			if ( $(this).attr('data-name') == $textarea.attr('data-name') ) {
				$(this).addClass('disabled');
			}
		});

		// Find any other answers that were selected before...
		$(document).find('.js-surveyAnswer').each(function() {
			if ( $(this).attr('data-name') == $textarea.attr('data-name') ) {
				$(this).removeClass('selected');
			}
		});

		$textarea.val('').removeClass('selected');
		$toggleBtn.removeClass('off');
	} else {
		// Disable the page "next" button
		$(document).find('.js-nextPage').each(function() {
			if ( $(this).attr('data-name') == $textarea.attr('data-name') ) {
				$(this).addClass('disabled');
			}
		});

		// Find any other answers that were selected before...
		$(document).find('.js-surveyAnswer').each(function() {
			if ( $(this).attr('data-name') == $textarea.attr('data-name') ) {
				$(this).removeClass('selected');
			}
		});

		$textarea.val('').addClass('selected');
		$toggleBtn.addClass('off');		
	}
}


